import { Tooltip, Tag } from "antd";
import { useMemo } from "react";
import { useUsageStore } from "../../../store/usage-store";
import { useUnstractSubscriptionPlanStore } from "../../store/unstract-subscription-plan-store";
import { TRIAL_PLAN } from "../../../helpers/GetStaticData";

function TrialDaysInfo() {
  const { llmTokenUsage } = useUsageStore();
  const { unstractSubscriptionPlan } = useUnstractSubscriptionPlanStore();

  // Fallback to 0 if remainingDays is null or undefined
  const daysLeft = unstractSubscriptionPlan?.remainingDays ?? 0;

  // Memoize the rounded token usage
  const llmTokenUsageRounded = useMemo(() => {
    if (llmTokenUsage !== undefined && llmTokenUsage !== null) {
      return (llmTokenUsage / 1000).toFixed(1);
    }
    return null;
  }, [llmTokenUsage]);

  // Memoize the trial days text
  const trialDaysText = useMemo(() => {
    if (daysLeft <= 0) {
      return "No trial days left";
    }
    if (llmTokenUsageRounded !== null) {
      return `Left in trial: ${daysLeft} days / ${llmTokenUsageRounded}K LLM Tokens`;
    }
    return `Left in trial: ${daysLeft} days`;
  }, [daysLeft, llmTokenUsageRounded]);

  // Memoize the tooltip title
  const trialTitle = useMemo(() => {
    if (llmTokenUsageRounded !== null) {
      return `You have ${daysLeft} days and ${llmTokenUsage} free LLM trial tokens left in your free trial. You can always connect your LLMs in case you run out of free tokens to continue.`;
    }
    return `You have ${daysLeft} days left in your free trial`;
  }, [daysLeft, llmTokenUsageRounded, llmTokenUsage]);

  if (unstractSubscriptionPlan?.planType !== TRIAL_PLAN) {
    return <></>;
  }

  return (
    <div className="trial-badge">
      <Tooltip title={trialTitle}>
        <Tag color="error">{trialDaysText}</Tag>
      </Tooltip>
    </div>
  );
}

export default TrialDaysInfo;
